import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="enter-submit"
export default class extends Controller {
  handle() {
    this.element.requestSubmit();
  }
}
